var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.486 20 0 15.514 0 10C0 4.486 4.486 0 10 0C15.514 0 20 4.486 20 10C20 15.514 15.514 20 10 20ZM10 1C5.03737 1 1 5.03737 1 10C1 14.9626 5.03737 19 10 19C14.9626 19 19 14.9626 19 10C19 5.03737 14.9626 1 10 1ZM9.1125 5.8875C9.1125 5.4 9.5125 5 10 5C10.5 5 10.8875 5.3875 10.8875 5.8875C10.8875 6.3875 10.5 6.775 10 6.775C9.5125 6.775 9.1125 6.375 9.1125 5.8875ZM9.34375 8.05H10.6562V15H9.34375V8.05Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.61b617d954cda782ba2e6589e4e15eff.svg";
export { ForwardRef as ReactComponent };